export class ResourceModel {
  id: string;
  name: string;
  documenttype: string[];
  documenturi: string;
  documentcategory: string;
  filetype: string;
  folder: string;
  publishon: string;
  unpublishon: string;
  permissions: string[] = [];
  notOnWeb: boolean | null;
  constructor(data?) {
    const resourceData = data || {};
    this.id = resourceData.id; 
    this.name = resourceData.name; 
    this.documenttype = resourceData.documentType ? resourceData.documentType.split(";") : []; 
    this.documenturi = resourceData.documentURI;
    this.documentcategory = resourceData.documentCategory;
    this.filetype = resourceData.fileType;
    this.folder = resourceData.folder;
    this.publishon = resourceData.publishOn;
    this.unpublishon = resourceData.unpublishOn;
    this.permissions = resourceData.permissions ? resourceData.permissions.map(item => item) : [];
    this.notOnWeb = resourceData.notOnWeb;
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/resource.model.ts